import { Box, SvgIconProps } from '@mui/material';
import React from 'react';
import { TimelineTypeEnum } from 'types/timeline.types';
import DoorIcon from './DoorIcon';
import LockIcon from './LockIcon';
import LogsIcon from './LogsIcon';
import PoliceBadgeIcon from './PoliceBadgeIcon';
import PurchaseOrderIcon from './PurchaseOrderIcon';
import SettingIcon from './SettingIcon';
import SirenIcon from './SirenIcon';
import TimerIcon from './Timercon';
import UnlockIcon from './UnlockIcon';
import WarningShieldIcon from './WarningShieldIcon';
import WholeHandIcon from './WholeHandIcon';

function TimelineIcon({ type, IconProps }: { type: TimelineTypeEnum; IconProps?: SvgIconProps }) {
  switch (type) {
    case TimelineTypeEnum.OFF_SCHEDULE:
      return (
        <TimelineIconContainer color="#007AFF">
          <TimerIcon fontSize="small" {...IconProps} />
        </TimelineIconContainer>
      );
    case TimelineTypeEnum.SERVICE_ORDER:
      return (
        <TimelineIconContainer color="#5856D6">
          <PurchaseOrderIcon fontSize="small" {...IconProps} />
        </TimelineIconContainer>
      );
    case TimelineTypeEnum.ALARM:
      return (
        <TimelineIconContainer color="#FF3B30">
          <SirenIcon fontSize="small" {...IconProps} />
        </TimelineIconContainer>
      );
    case TimelineTypeEnum.NO_CONTROL:
      return (
        <TimelineIconContainer color="#8E8E93">
          <SettingIcon fontSize="small" {...IconProps} />
        </TimelineIconContainer>
      );
    case TimelineTypeEnum.ARM:
      return (
        <TimelineIconContainer color="#FF9500">
          <LockIcon fontSize="small" {...IconProps} />
        </TimelineIconContainer>
      );
    case TimelineTypeEnum.DISARM:
      return (
        <TimelineIconContainer color="#1DD2AF">
          <UnlockIcon fontSize="small" {...IconProps} />
        </TimelineIconContainer>
      );
    case TimelineTypeEnum.TEST:
      return (
        <TimelineIconContainer color="#5856D6">
          <WholeHandIcon fontSize="small" {...IconProps} />
        </TimelineIconContainer>
      );
    case TimelineTypeEnum.PATROL:
      return (
        <TimelineIconContainer color="#34495E">
          <PoliceBadgeIcon fontSize="small" {...IconProps} />
        </TimelineIconContainer>
      );
    case TimelineTypeEnum.PANIC:
      return (
        <TimelineIconContainer color="#007AFF">
          <WarningShieldIcon fontSize="small" {...IconProps} />
        </TimelineIconContainer>
      );
    case TimelineTypeEnum.COMMAND:
      return (
        <TimelineIconContainer color="#5856D6">
          <DoorIcon fontSize="small" {...IconProps} />
        </TimelineIconContainer>
      );
    case TimelineTypeEnum.LOG:
      return (
        <TimelineIconContainer color="#1abc9c">
          <LogsIcon fontSize="small" {...IconProps} />
        </TimelineIconContainer>
      );
    default:
      return (
        <TimelineIconContainer color="#1abc9c">
          <LogsIcon fontSize="small" {...IconProps} />
        </TimelineIconContainer>
      );
  }
}

function TimelineIconContainer({ color, children }: { color: string; children: React.ReactNode }) {
  return (
    <Box
      sx={{
        p: 1.5,
        border: `1px ${color} solid`,
        borderRadius: '50%',
        mr: 1,
        color,
        display: 'flex',
      }}
    >
      {children}
    </Box>
  );
}

export default TimelineIcon;
